"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const useInputForm_1 = require("../../hooks/useInputForm");
const SelectDropdown_1 = __importDefault(require("../Select/SelectDropdown"));
const SelectButton_1 = __importDefault(require("../Select/SelectButton"));
const SelectOption_1 = __importDefault(require("../Select/SelectOption"));
const Select_1 = __importDefault(require("../Select/Select"));
const SelectButtonCaret_1 = __importDefault(require("../Select/SelectButtonCaret"));
const InputLabel_1 = __importDefault(require("./Base/InputLabel"));
const helpers_1 = require("../../lib/helpers");
const InputDiv_1 = __importDefault(require("./Base/InputDiv"));
const withJourney_1 = __importDefault(require("../../hocs/withJourney"));
const InputError_1 = __importDefault(require("./Base/InputError"));
const Spinner_1 = __importDefault(require("../Animation/Spinner"));
const SelectInput = (props) => {
    var _a, _b;
    const { nullable } = props;
    let optionsObj = {};
    if (Array.isArray(props.options)) {
        props.options.forEach((propValue) => {
            optionsObj[propValue] = propValue;
        });
    }
    else if (typeof optionsObj === 'object') {
        optionsObj = props.options;
    }
    const value = useInputForm_1.useInputValue(props);
    let selectedValue = (_b = (_a = optionsObj[value]) !== null && _a !== void 0 ? _a : props.placeholder) !== null && _b !== void 0 ? _b : 'Select an option';
    if (Array.isArray(value) && value.length > 0) {
        selectedValue = value.filter((row) => !!optionsObj[row]).map((row) => optionsObj[row]).join(', ');
    }
    if ((value === null || value === undefined) && nullable) {
        selectedValue = 'None';
    }
    const [busy, setBusy] = react_1.useState(false);
    const inputOnChange = useInputForm_1.useInputFormChange(props);
    const onChangeHandle = react_1.useCallback((e) => __awaiter(void 0, void 0, void 0, function* () {
        setBusy(true);
        try {
            yield inputOnChange(e);
        }
        finally {
            setBusy(false);
        }
    }), [inputOnChange]);
    return (react_1.default.createElement(InputDiv_1.default, { value: props.value, className: classnames_1.default(props.className, { disabled: props.disabled }), label: props.label, name: props.name, error: props.error },
        react_1.default.createElement(Select_1.default, Object.assign({}, helpers_1.without(props, ['onClick', 'className']), { value: value, onChange: onChangeHandle }),
            react_1.default.createElement(SelectButton_1.default, null,
                react_1.default.createElement(InputLabel_1.default, { className: "retracted" }),
                react_1.default.createElement("span", { className: "j-select-input-value" }, busy ? react_1.default.createElement(Spinner_1.default, null) : selectedValue),
                react_1.default.createElement(SelectButtonCaret_1.default, null)),
            react_1.default.createElement(SelectDropdown_1.default, null,
                nullable && (react_1.default.createElement(SelectOption_1.default, { checkedValue: "null" }, "None")),
                Object.keys(optionsObj).map((optionValue) => (react_1.default.createElement(SelectOption_1.default, { key: optionsObj[optionValue], checkedValue: optionValue, 
                    /* Provide the optionValue itself for array based selecting so in the form updater we can know what one we will uncheck. */
                    uncheckedValue: Array.isArray(value) ? optionValue : undefined }, optionsObj[optionValue]))))),
        react_1.default.createElement(InputError_1.default, null)));
};
exports.default = withJourney_1.default('j-select-input', SelectInput);
